module.exports = __webpack_public_path__ + "static/media/aboutus-img.f30703e3.svg";